export const RecentEventsData =[
    {
      "RecentEventName": "Cricket League",
      "Subheading": "Finals",
      "Image": require("../assets/recent-events/Cricket League.jpg"),
      "Description": ""
    },
    {
      "RecentEventName": "Weightlifting Workshop",
      "Subheading": "Upcoming",
      "Image": require("../assets/recent-events/Weightlifting Workshop.jpg"),
      "Description": ""
    },
    {
      "RecentEventName": "Basketball League",
      "Subheading": "Read More",
      "Image": require("../assets/recent-events/Basketball League.jpg"),
      "Description": ""
    }
   ]